/**
 * Text color for the CTA buttons shared by Hero, Text & Button, and Navbar.
 */

import { getButtonTextColor, isValidHexColor } from "@/features/landing-pages/_logic/color-utils";
import type { CtaButton } from "../../_types";

/**
 * Resolves a CTA button's text color: its own `textColor` override when set to a valid hex,
 * otherwise the automatic white-or-dark pick for its background.
 *
 * The override reaches an inline `style`, so anything that isn't a hex color is ignored rather
 * than rendered.
 *
 * @param button - The button (only `textColor` is read).
 * @param bgColor - The button's resolved background color (hex).
 * @returns The hex color to render the button's label in.
 */
export function resolveCtaButtonTextColor(button: Pick<CtaButton, "textColor">, bgColor: string): string {
  if (button.textColor && isValidHexColor(button.textColor)) return button.textColor;
  return getButtonTextColor(bgColor);
}
